import React, { Fragment } from 'react'
import { Field } from 'redux-form'
import {
    Create,
    SelectArrayInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'
import {
    TextInput,
    ReferenceSelectInput
} from '../Inputs'


export const UsuarioCoordinadoCreate = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    // const role = permissions.role

    return (
        <Fragment>
            <Title title={"Crear Usuario"} />
            <Create {...props}>
                <CustomSimpleForm>
                    <Field
                        name={"username"}
                        type="text"
                        label={'Username'}
                        required={true}
                        component={TextInput}
                    />
                    <Field
                        name={"email"}
                        type="text"
                        label={'email'}
                        required={true}
                        component={TextInput}
                    />
                    <Field
                        name={"first_name"}
                        type="text"
                        label={'Nombre'}
                        required={true}
                        component={TextInput}
                    />
                    <Field
                        name={"last_name"}
                        type="text"
                        label={'Apellido'}
                        component={TextInput}
                    />
                    <Field
                        name={"empresa"}
                        label={"Empresa"}
                        required={true}
                        component={ReferenceSelectInput}
                        reference={"empresas"}
                        isDisabled={false}
                        style={{marginTop: 20}}
                    />
                    <SelectArrayInput 
                        label="Permisos" 
                        source="permissions" 
                        choices={[
                            { id: 'read', name: 'Ver' },
                            { id: 'edit', name: 'Editar' },
                        ]} 
                    />
                </CustomSimpleForm>
            </Create>
        </Fragment>
    )
};
